// extracted by mini-css-extract-plugin
module.exports = {"container":"LMSErrorBoundary_container__2FKiv","title":"LMSErrorBoundary_title__2I7XO","subtitle":"LMSErrorBoundary_subtitle__2UGjB","action":"LMSErrorBoundary_action__PKoGG"};